// Shared storefront behavior. Section-specific scripts live next to their sections.
(function () {
  'use strict';

  window.Angar = window.Angar || {};

  // Formats a cents amount as MXN, matching the "$1,234 MXN" style used in the design.
  window.Angar.formatMoney = function (cents) {
    var value = Math.round(Number(cents) / 100);
    return '$' + value.toLocaleString('en-US') + ' MXN';
  };
})();
